// extracted by mini-css-extract-plugin
export var bodySections = "_ao-8";
export var gray = "_ao-7";
export var green = "_ao-4";
export var iconContainer = "_ao-9";
export var iconWidgetContainer = "_ao-1";
export var phoneIcon = "_ao-2";
export var red = "_ao-5";
export var statusDot = "_ao-3";
export var widgetContainer = "_ao-0";
export var yellow = "_ao-6";